import type { ProgressStore } from './types'

/** Хранилище в памяти. Для тестов и как запасной вариант. */
export class MemoryStore implements ProgressStore {
  private readonly data = new Map<string, string>()

  async get(key: string): Promise<string | null> {
    return this.data.get(key) ?? null
  }

  async set(key: string, value: string): Promise<void> {
    this.data.set(key, value)
  }

  async remove(key: string): Promise<void> {
    this.data.delete(key)
  }

  async keys(): Promise<string[]> {
    return [...this.data.keys()]
  }
}
